import { PeriodPickerProps } from '@touche-lts/panel-ui/dist/components/shared/period-picker'

export enum ProductsTableSortProps {
  ID = 'id',
  PRODUCT_NAME = 'name',
  STORE_NAME = 'storeName',
  ACTIVE_SKUS = 'skuCount',
  INVENTORY = 'inventory',
  SOLD = 'sold',
  REVENUE = 'revenue',
  DEPARTMENT = 'department',
  ADDED_DATE = 'createdDate'
}

export interface ProductsTableSearchProps {
  id: number
  productName: string
  storeName: string
  minSKUs: number
  maxSKUs: number
  minStock: number
  maxStock: number
  minSold: number
  maxSold: number
  minRevenue: number
  maxRevenue: number
  departmentName: string
  addedOnPeriod: PeriodPickerProps['period']
}
